import React, { useRef } from 'react';
import SearchComponent from './SearchComponent';
import { useZdsMenuHost } from '../hooks/useZdsMenuHost';

interface SearchControllerProps {
  navRootElement: Element | null;
  isVisible?: boolean;
}

const SearchController = ({
  navRootElement,
  isVisible = true,
}: SearchControllerProps) => {
  const menuElement = useZdsMenuHost({
    selector: 'z-search',
    isVisible,
    navRootElement,
  });
  // Remount SearchComponent when z-search is replaced (e.g. app switch) so
  // keyword/results state does not outlive an empty search box.
  // Only bump when swapping one live host for another — ignore transient null.
  const previousHostRef = useRef<Element | null>(null);
  const hostKeyRef = useRef(0);
  if (
    menuElement &&
    previousHostRef.current &&
    menuElement !== previousHostRef.current
  ) {
    hostKeyRef.current += 1;
  }
  if (menuElement) {
    previousHostRef.current = menuElement;
  }

  if (!isVisible || !menuElement) {
    return null;
  }

  return <SearchComponent key={hostKeyRef.current} menuElement={menuElement} />;
};

export default SearchController;
